import TimePeriod from './TimePeriod';

export default TimePeriod;
